// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"478":"1a12eab5","546":"7b4dbec5"}[chunkId] + ".chunk.css";
};